const flashMessage = (function () {
	const _message = document.getElementById('flash-message');
	let timer;
	
	if (!_message) {
		return;
	}
	
	function init() {
		if (util.hasClass(_message, 'is-visible')) {
			timer = setTimeout(hide, 7000);
		}
	}
	
	function hide() {
		util.removeClass(_message, 'is-visible');
		_message.removeAttribute('role');
		_message.innerHTML = '';
	}
	
	function show(type, text) {
		clearTimeout(timer);
		
		_message.innerHTML = text;
		
		if (type === 'error') {
			util.removeClass(_message, 'flash-message--info');
		} else {
			util.removeClass(_message, 'flash-message--error');
		}
		
		util.addClass(_message, `flash-message--${type}`);
		util.addClass(_message, 'is-visible');
		_message.setAttribute('role', 'alert');
		
		timer = setTimeout(hide, 5000);
	}
	
	init();
	
	return {
		hide: hide,
		show: show,
	};
}());